import { render, staticRenderFns } from "./ShareableGroupEditModal.vue?vue&type=template&id=25c06d8c&scoped=true&"
import script from "./ShareableGroupEditModal.vue?vue&type=script&lang=js&"
export * from "./ShareableGroupEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareableGroupEditModal.vue?vue&type=style&index=0&id=25c06d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c06d8c",
  null
  
)

export default component.exports